
define('text!gameday-index-mlbtv/src/templates/mlb-tv-link.mustache',[],function () { return '<a href="/mlb/subscriptions/index.jsp?product=mlbtv&affiliateId=ATBAT">Watch</a>';});

